import { httpGetAndParse } from '../../../../utils/fetchService';

export const fetchCategoryDetails = ({ taxYear, period, entityId, accountGroup }) =>
  httpGetAndParse({
    route: `/api/entities/category-details/${taxYear}/${period}/${entityId}/${accountGroup}`,
    errorMessage: 'Fetching Category details failed',
  });
